import { PreciseDosage } from '@dreryk/egabinet-prescription-frontend-api';

import { formatPreciseDosage } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

type NumericalDosageTextViewProps = {
   readonly preciseDosage: PreciseDosage | undefined;
};

export const NumericalDosageTextView = (props: NumericalDosageTextViewProps): JSX.Element => {
   return (
      <StyledPrescriptionTextView testId={'numericalDosage'} compact label={prescriptionTranslationKeys.dosage.dosage}>
         {props.preciseDosage ? formatPreciseDosage(props.preciseDosage) : '-'}
      </StyledPrescriptionTextView>
   );
};
